<template>
  <div>
    <v-container
      fluid
      class="fill-height"
    >
      <v-content>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            md="8"
          >
            <v-card class="elevation-12">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="5"
                class="elevation-1"
                no-data-text="No hay variables registradas."
                :loading="loading"
                loading-text="Cargando variables registradas."
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-btn
                      color="primary"
                      dark
                      @click="openForm"
                    >
                      Nueva variable
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    color="#63C891"
                    @click="editItem(item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    color="#F99191"
                    @click="deleteItem(item)"
                  >
                    delete
                  </v-icon>
                </template>
                <template v-slot:item.categories="{ item }">
                  <template v-if="item.categories">
                    <template v-for="category in item.categories">
                      <v-chip
                        class="ml-1"
                        x-small
                      >
                        {{category}}
                      </v-chip>
                    </template>
                  </template>
                  <template v-else>
                    <div class="no-categories-found">
                      no aplica
                    </div>
                  </template>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <variable-form
      :item="selectedItem"
      :show="showForm"
      @close="showForm = false"
      @updateList="updateList"
    />
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import VariableForm from '@/components/Variable/VariableForm.vue';

export default {
  name: 'Variables',
  components: {
    VariableForm,
  },
  data: () => ({
    headers: [
      { text: 'Nombre', value: 'name', align: 'center' },
      { text: 'Descripción', value: 'description', align: 'center' },
      { text: 'Tipo', value: 'type', align: 'center' },
      { text: 'Propiedad', value: 'property', align: 'center' },
      { text: 'Categorias', value: 'categories', align: 'center' },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    items: [],
    showForm: false,
    selectedItem: null,
    loading: false,
  }),
  watch: {
    showForm(val) {
      if (val === false) {
        this.selectedItem = null;
      }
    },
  },
  mounted() {
    this.updateList();
  },
  methods: {
    editItem(item) {
      this.selectedItem = item;
      this.openForm();
    },
    deleteItem(item) {
      Swal.fire({
        title: '¿Estas seguro?',
        text: 'Esta acción no se puede deshacer...',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.axios.delete(`/api/variables/${item.id}`)
            .then((response) => {
              if (response.status === 204) {
                Swal.fire(
                  'Eliminado!',
                  'La variable ha sido eliminada correctamente.',
                  'success',
                )
                  .then(() => {
                    this.updateList();
                  });
              }
            })
            .catch((error) => {
              Swal.fire(
                'Error',
                error.response.message,
                'error',
              );
            });
        } else {
          Swal.fire(
            'Cancelado',
            'La variable no ha sido eliminada.',
            'success',
          );
        }
      });
    },
    openForm() {
      this.showForm = true;
    },
    updateList() {
      this.loading = true;
      this.axios.get('/api/variables')
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.items = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
            Swal.fire({
              title: 'Lo sentimos',
              text: 'Su sesión ha expirado.',
              icon: 'error',
            })
              .then(() => {
                this.$emit('logout');
              });
          }
        });
    },
  },
};
</script>

<style type='text/css'>

  .no-categories-found {
    color: rgba(0, 0, 0, 0.38);
  }

</style>
